import {Component, Input} from '@angular/core';

@Component({
    selector: 'ac-label',
    templateUrl: './ac-label.component.html'
})
export class AcLabelComponent {
    @Input() ngClass: any;
}
